import { computed, defineComponent, onUpdated } from 'vue';
import { useStore } from 'vuex';
import { useDateFormat } from '@/composables/dateFormat';
import { AppointmentGetter } from '@/store/appointment/appointment.module';
import { Appointment } from '@/store/appointment/appointment.model';
import { AppointmentRegionGetter } from '@/store/appointmentRegion/appointmentRegion.module';
import { AppointmentRegion } from '@/store/appointmentRegion/appointmentRegion.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import AppointmentRegionListComponent from './appointmentRegionList/AppointmentRegionList.vue';

export default defineComponent({
  name: 'AppointmentDetailComponent',
  components: {
    LoadingComponent,
    AppointmentRegionListComponent,
  },
  emits: [
    'toggle',
    'show'
  ],
  props: {
    appointmentId: {
      type: Number,
    },
  },
  setup: (props, context) => {
    const store = useStore();
    const dateFormat = useDateFormat();
    const isLoading = computed(() => store.getters[AppointmentGetter.STATUS] === 'init' || store.getters[AppointmentGetter.STATUS] === 'loading');
    const appointment = computed<Appointment | undefined>(() => store.getters[AppointmentGetter.BY_ID](props.appointmentId));
    const appointmentRegions = computed<AppointmentRegion[]>(() => store.getters[AppointmentRegionGetter.ALL]);

    onUpdated(() => {
      if (!appointment.value) {
        context.emit('toggle', null);
      }
    });

    const backClick = () => {
      context.emit('toggle', null);
    };

    const editClick = () => {
      context.emit('show', appointment.value?.id);
    };

    const thaiDate = (date: Date) => dateFormat.toThaiDate(date, 'long');
    const statusHtml = (status: number) =>
      (status < 0)
        ? '<span class="text-danger">สิ้นสุดแล้ว</span>'
        : '<span class="text-success">กำลังใช้งาน</span>';

    return {
      appointment,
      appointmentRegions,
      isLoading,
      backClick,
      editClick,
      thaiDate,
      statusHtml,
    };
  },
});
